import React from "react";
import Search from "../Search";
import Rating from "../Rating";
import Zoom from "../Zoom";

export default function Config() {
  return (
    <nav className={"sticky top-0 h-auto z-30 max-w-6xl w-full"}>
      <form
        onSubmit={(e) => e.preventDefault()}
        className="py-4 px-4 shadow-lg bg-white ml-4 mt-4 mr-4 rounded-lg"
      >
        <h1 className="sr-only">Search Configuration</h1>
        {/* <Search></Search> */}
        {/* <InputHeader>Rating</InputHeader> */}
        {/* <Rating className="mr-auto"></Rating> */}
        <InputHeader>Zoom</InputHeader>
        <Zoom className=" w-40"></Zoom>
      </form>
    </nav>
  );
}

function InputHeader({ children }) {
  return (
    <h2 className="font-semibold text-gray-800 text-lg mb-2">{children}</h2>
  );
}
